module.exports = __webpack_public_path__ + "static/media/google.9367e4e3.svg";